module.exports = __webpack_public_path__ + "img/Alejandro.1ba6f143.jpg";